export const pathRoutes = {
  home: '/',
  chatBot: '/chatbot',
};